import { useLaunchpool } from '@flipster/features/src/shared/launchpool/state';

export const useLaunchpoolById = (id: number) => {
  const { launchpoolList } = useLaunchpool();
  return launchpoolList?.pools.find((pool) => pool.id === id);
};
